<template>
    <div v-if="article" class="grid grid-cols-5 lg:grid-cols-12 lg:gap-8 items-center lg:items-start">
        <MyAccountOrderEntryArticleMedium :article="article" :item="item" class="col-span-2 lg:col-span-2 p-4" />
        <MyAccountOrderEntryArticleTitle :article="article" class="col-span-3 lg:col-span-4 text-lg font-bold block" />
        <MyAccountOrderEntryArticleNumber :article="article" class="col-span-5 lg:col-span-2 border-b py-3 lg:border-0 lg:pb-0" />
        <MyAccountOrderEntryArticleUnitPrice :item="item" class="col-span-5 lg:col-span-2 text-right border-b py-3 lg:border-0 lg:pb-0" />
        <MyAccountOrderEntryArticleQuantity :item="item" class="col-span-5 lg:col-span-1 lg:text-right border-b py-3 lg:pb-0 lg:border-0" />
        <MyAccountOrderEntryArticleSum :item="item" class="col-span-5 lg:col-span-1 font-bold lg:text-right py-3 lg:border-0 lg:pb-0" />
    </div>
</template>
<script setup lang="ts">
    import type { OrderItem } from '~/composables/shoppingCartApi';
    import { getExpArticle } from "~/composables/ExpApi/expArticle";
    const props = defineProps({
        item: {
            type: Object as PropType<OrderItem>,
            required: true
        }
    });
    const article = ref();
    ;(async () => {
        article.value = (await getExpArticle(props?.item?.articleId))?.data?.value;
    })();
</script>